import React from "react";
import { costPrintedToManaFontClasses } from "utils/utils";

type Props = {
  costPrinted?: string;
  keyruneCode?: string;
};

export const CardSkeleton = ({ costPrinted }: Props) => {
  const manaSymbolCount = costPrintedToManaFontClasses(
    costPrinted || ""
  ).length;

  return (
    <div className="relative flex h-full w-full flex-col rounded-[4.75%/3.5%]">
      <div className="absolute inset-x-[3.3%] bottom-[3.3%] top-[4.2%] flex flex-col">
        {/* Card name and mana cost */}
        <div className="mb-1 flex items-center justify-between">
          <div className="skeleton h-5 w-2/3 animate-pulse" />
          <div className="flex shrink items-center gap-0.5">
            {[...Array(manaSymbolCount || 1)].map((_, index) => (
              <div
                key={index}
                className="skeleton h-4 w-4 animate-pulse rounded-full"
              />
            ))}
          </div>
        </div>

        {/* Card image */}
        <div className="mb-1 h-[45%]">
          <div className="skeleton h-full w-full animate-pulse rounded-sm" />
        </div>

        {/* Card type and set symbol */}
        <div className="mb-1 flex items-center justify-between">
          <div className="skeleton h-4 w-full animate-pulse" />
        </div>

        {/* Card text box */}
        <div className="grow">
          <div className="skeleton h-full w-full animate-pulse rounded-sm" />
        </div>
      </div>
    </div>
  );
};
